import api from "@services/api";
import axios from "axios";

interface IGetSchedule {
  dataInicio: string;
  dataFim: string;
}

class HomeService {
  async getScheduledByDate({ dataInicio, dataFim }: IGetSchedule) {
    const body = {
      dataInicio,
      dataFim,
    };

    try {
      const response = await api.get("/home/obter-por-data", {
        params: body,
      });

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const errorRes = error.response;
        return errorRes;
      }
    }
  }

  async getFixos() {
    try {
      const response = await api.get("/home/obter-fixos");

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const errorRes = error.response;
        return errorRes;
      }
    }
  }
}

const homeServiceInstance = new HomeService();
export default homeServiceInstance;
